// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Close button ── */
.tcm-close-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0.7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  color: #64748b;
  padding: 4px;
  outline: none;
}

.tcm-close-btn:hover {
  opacity: 1;
}

.tcm-close-btn svg {
  width: 16px;
  height: 16px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ── Header ── */
.tcm-header {
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
  padding: 20px 24px;
}

.tcm-header-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.tcm-title {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin: 0;
}

/* ── Body ── */
.tcm-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
}

/* ── Table Info ── */
.tcm-table-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background: rgba(248, 250, 252, 0.8);
  padding: 16px;
}

.tcm-info-label-table {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0;
}

.tcm-table-name {
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.tcm-capacity-box {
  border-radius: 16px;
  background-color: #ffffff;
  padding: 8px 12px;
  text-align: right;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.tcm-info-label-capacity {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
  margin: 0;
}

.tcm-capacity-value {
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

/* ── Pax Section ── */
.tcm-pax-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tcm-pax-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tcm-pax-header p {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0;
}

.tcm-pax-header span {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

.tcm-pax-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.tcm-pax-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  height: 44px;
  width: 44px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  color: #475569;
  background-color: #ffffff;
  cursor: pointer;
  padding: 0;
}

.tcm-pax-btn:hover:not(:disabled) {
  background-color: #f8fafc;
}

.tcm-pax-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.tcm-pax-btn svg {
  width: 16px;
  height: 16px;
}

.tcm-pax-middle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tcm-pax-selected-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0;
}

.tcm-pax-value {
  margin-top: 4px;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: -0.025em;
  color: #0f172a;
  line-height: 1;
}

.tcm-pax-input {
  display: flex;
  width: 100%;
  height: 44px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  padding: 4px 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  color: #0f172a;
  outline: none;
  transition: border-color 0.2s, background-color 0.2s;
}

.tcm-pax-input:focus {
  border-color: #cbd5e1;
  background-color: #ffffff;
}

.tcm-pax-input::-webkit-outer-spin-button,
.tcm-pax-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.tcm-pax-input[type=number] {
  -moz-appearance: textfield;
}

/* ── Footer ── */
.tcm-actions {
  display: flex;
  flex-direction: column-reverse;
  gap: 12px;
  border-top: 1px solid #f1f5f9;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 16px 24px;
}

@media (min-width: 640px) {
  .tcm-actions {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.tcm-btn-cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 8px 20px;
  color: #0f172a;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.tcm-btn-cancel:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.tcm-btn-confirm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
  border-radius: 16px;
  border: 1px solid #2563eb;
  background-color: #2563eb;
  padding: 8px 20px;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.tcm-btn-confirm:hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

/* ═══ DARK THEME — TableConfirmationModal ═══ */
.dark .tcm-header {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-bottom-color: #334155;
}
.dark .tcm-title { color: #f1f5f9; }

.dark .tcm-table-info {
  background: rgba(30, 41, 59, 0.8);
  border-color: #334155;
}
.dark .tcm-info-label-table  { color: #64748b; }
.dark .tcm-table-name        { color: #f1f5f9; }
.dark .tcm-capacity-box      { background-color: #0f172a; }
.dark .tcm-info-label-capacity { color: #64748b; }
.dark .tcm-capacity-value    { color: #f1f5f9; }

.dark .tcm-pax-header p      { color: #64748b; }
.dark .tcm-pax-header span   { color: #94a3b8; }
.dark .tcm-pax-control {
  background-color: #0f172a;
  border-color: #334155;
}
.dark .tcm-pax-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .tcm-pax-btn:hover:not(:disabled) { background-color: #334155; }
.dark .tcm-pax-selected-label { color: #64748b; }
.dark .tcm-pax-value          { color: #f1f5f9; }
.dark .tcm-pax-input {
  background-color: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}
.dark .tcm-pax-input:focus { background-color: #1e293b; border-color: #475569; }

.dark .tcm-actions {
  background-color: rgba(15, 23, 42, 0.7);
  border-top-color: #334155;
}
.dark .tcm-btn-cancel {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .tcm-btn-cancel:hover { background-color: #334155; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/TableConfirmationModal/TableConfirmationModal.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gEAAgE;EAChE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;AACA,mBAAmB,cAAc,EAAE;;AAEnC;EACE,iCAAiC;EACjC,qBAAqB;AACvB;AACA,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,yBAAyB,EAAE;AAC1D,iCAAiC,cAAc,EAAE;AACjD,+BAA+B,cAAc,EAAE;;AAE/C,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,cAAc,EAAE;AAC/C;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,0CAA0C,yBAAyB,EAAE;AACrE,gCAAgC,cAAc,EAAE;AAChD,gCAAgC,cAAc,EAAE;AAChD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,6BAA6B,yBAAyB,EAAE,qBAAqB,EAAE;;AAE/E;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,8BAA8B,yBAAyB,EAAE","sourcesContent":["/* ── Close button ── */\n.tcm-close-btn {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  opacity: 0.7;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s ease;\n  color: #64748b;\n  padding: 4px;\n  outline: none;\n}\n\n.tcm-close-btn:hover {\n  opacity: 1;\n}\n\n.tcm-close-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* ── Header ── */\n.tcm-header {\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n  padding: 20px 24px;\n}\n\n.tcm-header-text {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.tcm-title {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #0f172a;\n  margin: 0;\n}\n\n/* ── Body ── */\n.tcm-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px;\n}\n\n/* ── Table Info ── */\n.tcm-table-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background: rgba(248, 250, 252, 0.8);\n  padding: 16px;\n}\n\n.tcm-info-label-table {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.tcm-table-name {\n  margin-top: 4px;\n  margin-bottom: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.tcm-capacity-box {\n  border-radius: 16px;\n  background-color: #ffffff;\n  padding: 8px 12px;\n  text-align: right;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.tcm-info-label-capacity {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.tcm-capacity-value {\n  margin-top: 4px;\n  margin-bottom: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* ── Pax Section ── */\n.tcm-pax-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tcm-pax-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.tcm-pax-header p {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.tcm-pax-header span {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.tcm-pax-control {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 12px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.tcm-pax-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s, border-color 0.2s, color 0.2s;\n  height: 44px;\n  width: 44px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  color: #475569;\n  background-color: #ffffff;\n  cursor: pointer;\n  padding: 0;\n}\n\n.tcm-pax-btn:hover:not(:disabled) {\n  background-color: #f8fafc;\n}\n\n.tcm-pax-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.tcm-pax-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.tcm-pax-middle {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tcm-pax-selected-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.tcm-pax-value {\n  margin-top: 4px;\n  font-size: 36px;\n  font-weight: 900;\n  letter-spacing: -0.025em;\n  color: #0f172a;\n  line-height: 1;\n}\n\n.tcm-pax-input {\n  display: flex;\n  width: 100%;\n  height: 44px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 4px 12px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n  color: #0f172a;\n  outline: none;\n  transition: border-color 0.2s, background-color 0.2s;\n}\n\n.tcm-pax-input:focus {\n  border-color: #cbd5e1;\n  background-color: #ffffff;\n}\n\n.tcm-pax-input::-webkit-outer-spin-button,\n.tcm-pax-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.tcm-pax-input[type=number] {\n  -moz-appearance: textfield;\n}\n\n/* ── Footer ── */\n.tcm-actions {\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 12px;\n  border-top: 1px solid #f1f5f9;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 16px 24px;\n}\n\n@media (min-width: 640px) {\n  .tcm-actions {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n.tcm-btn-cancel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  height: 44px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 8px 20px;\n  color: #0f172a;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.tcm-btn-cancel:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.tcm-btn-confirm {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  height: 44px;\n  border-radius: 16px;\n  border: 1px solid #2563eb;\n  background-color: #2563eb;\n  padding: 8px 20px;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.tcm-btn-confirm:hover {\n  background-color: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n/* ═══ DARK THEME — TableConfirmationModal ═══ */\n.dark .tcm-header {\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  border-bottom-color: #334155;\n}\n.dark .tcm-title { color: #f1f5f9; }\n\n.dark .tcm-table-info {\n  background: rgba(30, 41, 59, 0.8);\n  border-color: #334155;\n}\n.dark .tcm-info-label-table  { color: #64748b; }\n.dark .tcm-table-name        { color: #f1f5f9; }\n.dark .tcm-capacity-box      { background-color: #0f172a; }\n.dark .tcm-info-label-capacity { color: #64748b; }\n.dark .tcm-capacity-value    { color: #f1f5f9; }\n\n.dark .tcm-pax-header p      { color: #64748b; }\n.dark .tcm-pax-header span   { color: #94a3b8; }\n.dark .tcm-pax-control {\n  background-color: #0f172a;\n  border-color: #334155;\n}\n.dark .tcm-pax-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .tcm-pax-btn:hover:not(:disabled) { background-color: #334155; }\n.dark .tcm-pax-selected-label { color: #64748b; }\n.dark .tcm-pax-value          { color: #f1f5f9; }\n.dark .tcm-pax-input {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n.dark .tcm-pax-input:focus { background-color: #1e293b; border-color: #475569; }\n\n.dark .tcm-actions {\n  background-color: rgba(15, 23, 42, 0.7);\n  border-top-color: #334155;\n}\n.dark .tcm-btn-cancel {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .tcm-btn-cancel:hover { background-color: #334155; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
